export const FALL_RISK_HARIZMI = {
    masterTableName: "MC_FALL_RISK_HARIZMI",
    tableName: "MC_FALL_RISK_HARIZMI_DET",
    columnName: "FRH_ID",
    columnValue: 0,
    title: "fall-risk-harizmi.title",
    rows: [
        {
            title: "id",
            value: "ID",
        },
        {
            title: "date",
            value: "PROCESS_TIME",
            type: "Date",
        },
        {
            title: "justification-evaluation",
            value: "JUSTIFICATION_EVALUATIO_XNAME",
        },
        {
            title: "age",
            value: "AGE_XNAME",
        },
        {
            title: "fall-history",
            value: "FALL_HISTORY",
            type: "Checkbox",
        },
        {
            title: "diseases",
            value: "DISEASES_XNAME",
        },
        {
            title: "sight-condition",
            value: "SIGHT_CONDITION_XNAME",
        },
        {
            title: "medicine",
            value: "MEDICINE",
            type: "Checkbox",
        },
        {
            title: "equipment",
            value: "EQUIPMENT",
            type: "Checkbox",
        },
        {
            title: "walker-support",
            value: "WALKER_SUPPORT",
            type: "Checkbox"
        },
        {
            title: "sedasyon-anestezi",
            value: "SEDASYON_ANESTEZI_XNAME",
        },
        {
            title: "mental-state",
            value: "MENTAL_STATE",
            type: "Checkbox"
        },
        {
            title: "stability",
            value: "STABILITY",
            type: "Checkbox"
        },
        {
            title: "bed",
            value: "BED",
            type: "Checkbox"
        },
        {
            title: "family-information",
            value: "FAMILY_INFORMATION",
            type: "Checkbox"
        },
        {
            title: "fall-risk-harizmi-score",
            value: "CALC_VALUE",
        },
        {
            title: "note",
            value: "NURSE_NOTE",
        },
    ],
    fields: [
        { field: "date", headerName: "datetime", flex: 1 },
        { field: "justification-evaluation", headerName: "fall-risk-harizmi.justification-evaluation", flex: 1 },
        { field: "age", headerName: "fall-risk-harizmi.age", flex: 1 },
        { field: "fall-history", headerName: "fall-risk-harizmi.fall-history", flex: 1 },
        { field: "diseases", headerName: "fall-risk-harizmi.diseases", flex: 1 },
        { field: "sight-condition", headerName: "fall-risk-harizmi.sight-condition", flex: 1 },
        { field: "medicine", headerName: "fall-risk-harizmi.medicine", flex: 1 },
        { field: "equipment", headerName: "fall-risk-harizmi.equipment", flex: 1 },
        { field: "walker-support", headerName: "fall-risk-harizmi.walker-support", flex: 1 },
        { field: "sedasyon-anestezi", headerName: "fall-risk-harizmi.sedasyon-anestezi", flex: 1 },
        { field: "mental-state", headerName: "fall-risk-harizmi.mental-state", flex: 1 },
        { field: "stability", headerName: "fall-risk-harizmi.stability", flex: 1 },
        { field: "bed", headerName: "fall-risk-harizmi.bed", flex: 1 },
        { field: "family-information", headerName: "fall-risk-harizmi.family-information", flex: 1 },
        {
            field: "fall-risk-harizmi-score",
            headerName: "score",
            flex: 1,
            computed: true,
            calculate: (row: any) => {
                const ageScore = Number(row.AGE_XVALUE) || 0;
                const fallHistoryScore = row.FALL_HISTORY == 1 ? 2 : 0;
                const diseasesScore = Number(row.DISEASES_XVALUE) || 0;
                const sightConditionScore = Number(row.SIGHT_CONDITION_XVALUE) || 0;
                const medicineScore = row.MEDICINE == 1 ? 2 : 0;
                const equipmentScore = row.EQUIPMENT == 1 ? 2 : 0;
                const walkerSupportScore = row.WALKER_SUPPORT == 1 ? 10 : 0;
                const sedasyonAnestezi = Number(row.SEDASYON_ANESTEZI_XVALUE) || 0;
                const mentalStateScore = row.MENTAL_STATE == 1 ? 3 : 0;
                const stabilityScore = row.STABILITY == 1 ? 3 : 0;
                const bedScore = row.BED == 1 ? 2 : 0;
                const familyInformationScore = row.FAMILY_INFORMATION == 1 ? 2 : 0;

                return (
                    ageScore +
                    fallHistoryScore +
                    diseasesScore +
                    sightConditionScore +
                    medicineScore +
                    equipmentScore +
                    walkerSupportScore +
                    sedasyonAnestezi +
                    mentalStateScore +
                    stabilityScore +
                    bedScore +
                    familyInformationScore
                );
            },
        },
        { field: "note", headerName: "note", flex: 1 },
    ],
    mcpConfig: {
        JUSTIFICATION_EVALUATION: { mcpId: 82, field: "JUSTIFICATION_EVALUATION", scoreField: "JUSTIFICATION_EVALUATION" },
        AGE: { mcpId: 70, field: "AGE", scoreField: "AGE" },
        DISEASES: { mcpId: 71, field: "DISEASES", scoreField: "DISEASES" },
        SIGHT_CONDITION: { mcpId: 73, field: "SIGHT_CONDITION", scoreField: "SIGHT_CONDITION" },
        SEDASYON_ANESTEZI: { mcpId: 77, field: "SEDASYON_ANESTEZI", scoreField: "SEDASYON_ANESTEZI" },
    } as Record<string, { mcpId: number; field: string; scoreField: string }>,
    formData: {
        FRH_ID: "",
        PROCESS_TIME: new Date(),
        NURSE_ID: "",
        CTIME: new Date(),
        CUSER: "",
        NURSE_NOTE: "",
        GENARAL_NOTE: "",
        JUSTIFICATION_EVALUATION: "",
        AGE: "",
        FALL_HISTORY: "",
        DISEASES: "",
        SIGHT_CONDITION: "",
        MEDICINE: "",
        EQUIPMENT: "",
        WALKER_SUPPORT: "",
        SEDASYON_ANESTEZI: "",
        MENTAL_STATE: "",
        STABILITY: "",
        BED: "",
        FAMILY_INFORMATION: "",
        CALC_VALUE: 0,
    },
    chartScoreField: "CALC_VALUE",
    chartTimeField: "PROCESS_TIME",
};
